exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fullview {\n    width: 100%;\n    height: 100%;\n    background: #fefefe;\n    position: fixed;\n    top: 0;\n    left: 0;\n}\n.halfview {\n    width: 100%;\n    height: 100%;\n    background: #fefefeaa;\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 100;\n}\n.loading-spacer {\n    height: 30%;\n}\n", ""]);

// exports
